import { CanActivateFn, Router } from '@angular/router';
import { CompanyService, ICompanyReturn } from '../company/company.service';
import { inject } from '@angular/core';
import { ROUTER_TOKENS } from '../../app.routes';
import { concatMap, map, of, tap } from 'rxjs';
import { AuthStore } from '../auth/auth.store';
import { USER_META_STATE, USER_ROLE } from '../auth/auth.interface';
import { UserService } from '../user/user.service';
import { AuthFacade } from '../auth/auth.facade';
import { LoggingService } from '../utils/logging.service';
import { MappingService } from '../utils/mapping.service';
import { PhoneNumberFormat } from 'google-libphonenumber';

export const companyGuard: CanActivateFn = () => {
  const companyService = inject(CompanyService);
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const authFacade = inject(AuthFacade);
  const userService = inject(UserService);
  const loggingService = inject(LoggingService);
  const mappingService = inject(MappingService);

  loggingService.warn('💂1️⃣###COMPANY GUARD###');
  loggingService.warn('$$$authState-role', authStore.role);
  loggingService.warn('$$$authState-userState', authStore.userState);

  if (authFacade.userRole() == USER_ROLE.OWNER && authFacade.userMetaState() === USER_META_STATE.NEW_OWNER) {
    loggingService.error('new owner -> create business with owner');
    router.navigate([`/${ROUTER_TOKENS.LOGIN_PROFILE}`]);
  }
  // else if (authStore.role === ROLE.OWNER) {
  //   const business = companyService.getBusiness();
  //   loggingService.warn('business', business);
  // }

  // For Test
  const permissionManage = true;
  // localStorage.setItem('permissionManage', JSON.stringify(permissionManage));
  loggingService.log('permissionManage |||| ', permissionManage);
  authStore.setPermissionManage(permissionManage);

  return userService.getUserDetail(authStore.role, authStore.userId).pipe(
    concatMap((res: any) => {
      if (!res.country) {
        res.country = 'TH';
      }

      if (res?.mobile && typeof res.mobile === 'string' && res.mobile.startsWith('+')) {
        loggingService.warn('Converted Mobile', res?.mobile);
        const Mobile = [res.mobile];
        return mappingService.convertMobileCountryCodeByFormat(Mobile, res.country, PhoneNumberFormat.NATIONAL).pipe(
          tap((formattedPhones: string[]) =>
            loggingService.warn('TAP | data[CompEcomCustomerService] =>', formattedPhones)
          ),
          map((convertedMobile) => {
            loggingService.warn('Converted Mobile', convertedMobile);
            res.mobile = convertedMobile[0] || res.mobile;
            return res;
          })
        );
      }
      return of(res);
    }),
    // Get User Detail
    tap((res: any) => {
      loggingService.warn('getUserDetail', res);
      loggingService.warn('getUserDetail aasdasdasd', res);
      authStore.setUserProfileSystemState(res);
      companyService.setBizState(res.businessId);
      authStore.setSystemManage(false);
    }),
    concatMap((res) => {
      if (authStore.role === USER_ROLE.OWNER) {
        // Owner Alway Have Permission System Manage
        authStore.setSystemManage(true);
      }
      if (authStore.role === USER_ROLE.SUPER_ADMIN) {
        // Get Permission super-admin
        return userService.getRoleDetail(USER_ROLE.SUPER_ADMIN, res.id).pipe(
          tap((res: any) => {
            loggingService.warn('Get Role detail Guard :', res);
            // Set Role Super Admin State
            authStore.setRoleSuperAdminState(res);
            const systemRole = res.find((res: any) => res.name === 'ระบบจัดการ System Admin');
            if (systemRole) {
              const systemManage = systemRole.permissions.includes('system-manage');
              loggingService.warn('systemManage Guard', systemManage);
              // Set System Manage State
              authStore.setSystemManage(systemManage);
            }
          })
        );
      } else {
        if (authStore.role === USER_ROLE.ADMIN || authStore.role === USER_ROLE.STAFF) {
          return res.companies;
        } else {
          return of({});
        }
      }
    }),
    concatMap((roleRes: any) => {
      // Get Company
      if (authStore.role === USER_ROLE.SUPER_ADMIN || authStore.role === USER_ROLE.OWNER) {
        return companyService.getCompanyList().pipe(
          map((res: ICompanyReturn[] | any) => {
            // filter company active
            const activeCompanies = res.filter((company: ICompanyReturn) => company.isActive);

            if (activeCompanies.length) {
              companyService.setCompanyListState(activeCompanies);
              return true;
            } else {
              if (authStore.systemManage) {
                companyService.setCompanyListState(activeCompanies);
                return true;
              } else {
                return true;
              }
            }
          })
        );
      } else {
        // Admin And Staff Not Get Company List
        if (!roleRes) {
          // No Company
          return of(true);
        } else {
          // Set Company List State
          companyService.setCompanyListState([roleRes]);
          return of(true);
        }
      }
    })
  );
};
